import React, { useEffect, useState, useMemo } from 'react'
import { DialogContent, Typography, IconButton, Icon, MenuItem, Avatar } from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import StyledDialog from '../../Common/Dialogs/StyledDialog'
import StyledDatePicker from '../../Common/StyledDatePicker'
import StyledKeyboardTimePicker from '../../Common/StyledKeyboardTimePicker'
import CalendarIconButton from '../../Common/Buttons/CalendarIconButton'
import { MainButton } from '../../Button/MainButton'
import { TRAINING_PAGE_IDS, standardizeStartOfDateUTC } from '../../../utils'
import useSelectedFacility from '../../../hooks/useSelectedFacility'
import SearchClient from './SearchClient'
import { ArrowBackIosOutlined, ArrowForwardIosOutlined, AddOutlined } from '@material-ui/icons'
import { gray } from '../../../utils/colors'
import { FONT_WEIGHTS } from '../../../utils'
import DangerConfirmationDialog from '../../Common/Dialogs/DangerConfirmation'
import StandardConfirmationDialog from '../../Common/Dialogs/StandardConfirmation'
import moment from 'moment'
import StyledAlert from '../../Common/StyledAlert'
import StyledTextField from '../../Common/StyledTextField'

const useStyles = makeStyles((theme) => ({
	dialogContent: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		padding: '0 1.5rem',
		gap: '1rem',
		flex: 1
	},
	rowWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '1rem'
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		'& > div': {
			flex: 1
		},
		gap: '1.5rem'
	},
	dialogActions: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		gap: '1rem',
		margin: '2rem 0 1rem 0',
		'& .MuiButton-outlinedSizeLarge': {
			height: 'unset'
		},
		justifySelf: 'flex-end'
	},
	datePicker: {
		margin: 0,
		'& .MuiInputLabel-filled': {
			transform: 'translate(48px, 20px) scale(1)'
		},
		'& .MuiInputLabel-shrink': {
			transform: 'translate(48px, 10px) scale(0.75)'
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	attendeesHeaderContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: '.45rem'
	},
	attendeesContainer: {
		overflow: 'scroll',
		border: `1px solid ${gray[400]}`,
		borderRadius: '.375rem',
		padding: '1rem',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start'
	},
	attendee: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: '.4rem',
		'& > span': {
			fontSize: '1rem',
			fontWeight: 600
		}
	},
	sectionHeader: {
		fontFamily: 'Nunito',
		fontWeight: FONT_WEIGHTS.ExtraBold,
		fontSize: '0.75rem',
		textTransform: 'uppercase',
		letterSpacing: '0.047rem'
	}
}))

/**
 *
 * @param {{
  open: Boolean, 
	onSaved: Function,
	onClose: Function, 
	onCancelled: Function,
	title: String,
	trainingClass: Object,
	session: Object,
}} params
 * @returns
 */
const DogBeefDialog = ({
	open,
	setOpen,
	onSaved,
	onCancelled,
	onClose,
	title = 'Edit Dog Incompatibility',
	trainingClass,
	session = {},
	pet = {},
	updateBeefs,
	addBeefs
}) => {

	const classes = useStyles()
	const theme = useTheme()

	const [addAttendeeDialogOpen, setAddAttendeeDialogOpen] = useState(false)

	const [errors, setErrors] = useState([])
	const [loading, setLoading] = useState(false)


	const handleOnCancelled = () => {
		if (onCancelled) {
			onCancelled()
		}
	}

	const handleOnClosed = () => {
		if (onClose) {
			handleResetDialog()
			onClose()
		}
	}

	const handleOnSave = async () => {
		setOpen(false)
	}

	const canSave = () => {
		return true
	}

	const removeBeef = (beefId) => {
		const newBeefs = pet.beefs.filter((beef) => beef._id !== beefId)

		updateBeefs(newBeefs)
	}

	
	return (
		<>
			<StyledDialog
				open={open}
				onClose={handleOnClosed}
				title={title?.toUpperCase()}
				showActivityIndicator={loading}
				width={577}
				maxWidth={577}
				minWidth={577}>
				<DialogContent style={{ display: 'flex' }}>
					<div className={classes.dialogContent}>
						<div className={classes.rowWrapper}>
							<div className={classes.row}>
								<div>
									
								</div>
							</div>
							<div className={classes.row}>
								<div>
									
								</div>
							</div>
							
							
							<div>
								<div className={classes.attendeesHeaderContainer}>
									<Typography variant="h3" className={classes.sectionHeader}>
										Dog Beef
									</Typography>
									<MainButton
										label="Add Pet"
										variant="text"
										onClick={() => setAddAttendeeDialogOpen(true)}
										style={{ padding: `0 .5rem`, fontSize: '.85rem' }}
										startIcon={
											<AddOutlined
												style={{
													marginRight: 0,
													fill: theme.palette.secondary.main
												}}
											/>
										}
									/>
								</div>
								<div className={classes.attendeesContainer}>
									{pet?.beefs?.length
										? pet.beefs.map((dog) => {
												return (
													<div
														style={{ marginBottom: 12 }}
														className={classes.attendee}
														key={dog._id}>
														<IconButton
															onClick={() => removeBeef(dog._id)}>
															<Icon
																className="fas fa-minus-circle"
																style={{
																	fontSize: '1rem',
																	overflow: 'unset',
																	color: 'red'
																}}
															/>
														</IconButton>
														<Avatar src={dog.image_url} style={{ marginRight: 12, marginLeft: 4 }}/>
														<Typography variant="inherit">
															{dog.full_name}
														</Typography>
													</div>
												)
										  })
										: null}
								</div>
							</div>
							{errors.length > 0 ? (
								<div>
									{errors.map((error, i) => {
										const { message = 'Error Saving' } = error
										return <StyledAlert key={`error-${i}`} type="error" text={message} />
									})}
								</div>
							) : null}
						</div>
						<div className={classes.dialogActions}>
							<MainButton
								label="SAVE"
								onClick={handleOnSave}
								variant="contained"
								disabled={!canSave()}
							/>
							<MainButton label="Cancel" onClick={handleOnCancelled} />
						</div>
					</div>
				</DialogContent>
			</StyledDialog>
			<SearchClient
				open={addAttendeeDialogOpen}
				onClose={() => setAddAttendeeDialogOpen(false)}
				onSaved={(wat) => {
					console.log('wat', wat)
				}}
				onCancelled={() => setAddAttendeeDialogOpen(false)}
				title="Add Pet"
				showActivityIndicator={loading}
				trainingClass={trainingClass}
				session={session}
				pet={pet}
				addBeefs={addBeefs}
			/>
		</>
	)
}

export default DogBeefDialog
